/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { FormControlLabel, Switch, Typography } from "@mui/material";
import { useCurrentDynamicField } from "cms/fields/dynamic-field/hooks/use-current-dynamic-field";
import { useSelectFieldSchema } from "cms/fields/dynamic-field/hooks/use-select-field-schema";
import { useUpdateFieldSetting } from "cms/fields/hooks/use-update-field";
import { SVGIcons } from "cms/icons/svg-icons";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Logger, red } from "cms/utils/log/logger";
// import { useFieldZone } from "cms/fields/context/use-field-zone";
// import { set } from "lodash";

const HideFieldButton = () => {
    
    const { t } = useTranslation();
    const { field } = useCurrentDynamicField();
    const { updateFieldSetting } = useUpdateFieldSetting();
    // const { applyFieldChanges } = useFieldZone();
    
    // field
    const name = field?.name;
    const settings = field?.settings;
    // const values = field?.values;
    const type = field?.type;
    // const list = field?.list;
    // const position = field?.position;
    // const canUseDefaults = field?.canUseDefaults;
    // const wasAlreadyDefault = field?.wasAlreadyDefault;
    // const defaultImpl = field?.defaultImpl;
    
    // field settings
    const hide = settings?.hide ?? false;
    // const style = settings?.style ?? false;
    // const format = settings?.format ?? false;
    // const options = settings?.options ?? false;
    // const applyUnifiedSettings = settings?.applyUnifiedSettings ?? false;
    
    // schema
    const schema = useSelectFieldSchema(name);
    
    // schema settings
    const schemaSettings = schema?.settings;
    const noOverride = schemaSettings?.noOverride ?? false;
    const hidden = schemaSettings?.hidden ?? false;

    const [hideToggle, setHideToggle] = useState(true);
    
    useEffect(() => {
        Logger.info(red(`setHide [hide: ${hide}] [name: ${name}] [type: ${type}]`));
        setHideToggle(hide);
    }, [hide, name, type]);

    /**
     * @param event
     * @param value
     */
    const onChangeHide = (event, value) => {
        setHideToggle(value);
        updateFieldSetting("hide", value);
        // const next = structuredClone(field);
        // set( next, ["settings", "hide"], value);
        // applyFieldChanges(field, next);
    };
    
    return (
        <Fragment>
            
            {/*  This toggle should set the hide value of the settings in the model */}
            {/*  if 'hidden' in the model schema settings is true,  */}
            {/*  - this toggle should not be shown, and the user can't change 'hide'  */}
            {/*  - and a text message is shown instead   */}
            
            {!hidden && (
                <FormControlLabel
                    control={(
                        <Switch
                            name={`${name}_required`}
                            size='small'
                            checked={hideToggle}
                        />
                    )}
                    label={t("commons.hideFromDisplay")}
                    labelPlacement='end'
                    disabled={noOverride}
                    onChange={onChangeHide}
                    style={{ marginLeft: "4px", marginBottom: "4px", marginTop: "4px" }}
                />
            )}
            
            {hidden && (
                <>
                    <Typography
                        variant='body1'
                        style={{
                            display: "flex", alignItems: "center",
                            lineHeight: "20px", margin: "4px"
                        }}
                    >
                        <SVGIcons.common.Info style={{ marginRight: "12px" }} />
                        {t("commons.thisContentIsNotForDisplay")}
                    </Typography>
                </>
            )}
            
        </Fragment>
    );
};

export { HideFieldButton };
